import React from 'react';
import { makeStyles, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

interface PageSpinnerProps {
  isLoading?: boolean;
  children: React.ReactNode;
}

const PageSpinner: React.FC<PageSpinnerProps> = ({ isLoading, children }) => {
  const classes = useStyles();
  return (
    <>
      {isLoading ? (
        <div className={classes.container}>
          <CircularProgress color="secondary" />
        </div>
      ) : (
        children
      )}
    </>
  );
};

export default PageSpinner;
